import { columnsAddField } from '@/public/utils'
// import { getCookie, getParmUrl, outformat,getModerId } from '../../public/utils'
import React from 'react';
import _, { get, set } from 'lodash'

const toPoDetail = (poid) => {
    return '/main/POInfoListTab?poid=' + poid
}
export const getDifferenceColumns = (props) => {
    var columns = [
        {
            key: 'po_code',
            title: '采购订单号',
            dataIndex: 'po_code',
            align: 'center',
            features: { autoRowSpan: true },
            render: (text, record) => text||'-'
        },
        {
            key: 'product_code',
            title: '货品编码',
            dataIndex: 'product_code',
            align: 'center',
            features: { autoRowSpan: true },
        },
        {
            key: 'instock_info',
            title: '来货批号：来货数量',
            dataIndex: 'instock_info',
            align: 'center',
            render: (text, record) => {
                return get(record, 'delivery_info.length') ?
                    get(record, 'delivery_info').map(item => <p>{get(item, 'batch_no') || '-'}:{get(item, 'qty')}</p>):"-"
            }
        },
        {
            key: 'diff_key_all_in_stock_quantity',
            title: '入库批号：入库数量',
            dataIndex: 'diff_key_all_in_stock_quantity',
            align: 'center',
            features: { autoRowSpan: true },
            render: (text, record) => {
                return get(record, 'instock_info.length') ?
                    get(record, 'instock_info').map(item => <p>{get(item, 'batch_no') || '-'}:{get(item, 'qty')}</p> ):"-"
            }
        },
        // {
        //     key: 'diff_key_diff_info',
        //     title: '说明',
        //     dataIndex: 'diff_key_diff_info',
        //     align: 'center',
        //     features: { autoRowSpan: true },
        //     render: (text, record) => get(record, 'diff_info')
        // },
    ]
    return columnsAddField(columns)
}



// WEBPACK FOOTER //
// ./src/pages/deliverGoodsNew/config.js